import { z } from 'zod';

import { dependenciesResponseSchema } from '@/schemas/commons';
import type { ZodUseQuery } from '@/utils/zodReactQuery';

export const dependenciesResponse = dependenciesResponseSchema;
export type DependenciesResponse = z.infer<typeof dependenciesResponse>;
export type UseDependencies = ZodUseQuery<DependenciesResponse>;
